type AppEnv = "dev" | "test" | "live" | "same-origin";

/**
 * Known CMS hosts → use matching VITE_* env URLs.
 * Localhost → always "dev" (frontend talks to remote API from .env).
 * Any other host (white-label / customer deploy) → same-origin API.
 * Host matching kept for env detection (not user-facing branding).
 */
const getEnv = (): AppEnv => {
  const host = window.location.host;

  if (
    host.includes("localhost") ||
    host.includes("127.0.0.1") ||
    host.includes("dev2.sianty.com")
  ) {
    return "dev";
  }
  if (host.includes("dev4.sianty.com")) return "test";
  if (host.includes("cms.sianty.com")) return "live";

  // Deployed on customer / white-label domain (e.g. panel.maintorawms.com)
  return "same-origin";
};

/**
 * Vite only statically replaces `import.meta.env.VITE_*` keys.
 * Dynamic `import.meta.env[\`VITE_${x}\`]` is unreliable in production builds,
 * so map each env var explicitly (same keys as former REACT_APP_*).
 */
const ENV_URLS = {
  DEV_BASE_URL: import.meta.env.VITE_DEV_BASE_URL,
  DEV_CMS_URL: import.meta.env.VITE_DEV_CMS_URL,
  DEV_POS_URL: import.meta.env.VITE_DEV_POS_URL,
  TEST_BASE_URL: import.meta.env.VITE_TEST_BASE_URL,
  TEST_CMS_URL: import.meta.env.VITE_TEST_CMS_URL,
  TEST_POS_URL: import.meta.env.VITE_TEST_POS_URL,
  LIVE_BASE_URL: import.meta.env.VITE_LIVE_BASE_URL,
  LIVE_CMS_URL: import.meta.env.VITE_LIVE_CMS_URL,
  LIVE_POS_URL: import.meta.env.VITE_LIVE_POS_URL,
} as const;

export const checkUrl = (type: "BASE" | "CMS" | "POS"): string | undefined => {
  const env = getEnv();

  // White-label / any unknown deploy host → hit that server's own origin
  if (env === "same-origin") {
    return window.location.origin;
  }

  const key = `${env.toUpperCase()}_${type}_URL` as keyof typeof ENV_URLS;
  return ENV_URLS[key];
};
